import { useTranslation } from "react-i18next";
import { namespaces } from "../../i18n/i18n.constants";
import vegaLogo from "../../images/vega-logo.svg";
import linkedinIcon from "../../images/icons/linkedin.svg";
import { footerLinks } from "./footerLinks";
import "./Footer.scss";

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <div className="app-footer-content">
                <div className="app-footer-copyright">
                    <img src={vegaLogo} alt="Vega logo" className="app-footer-logo" />
                    <span>{t("footer.copyright", { year: currentYear, ns: namespaces.common })}</span>
                    <a
                        href="https://linkedin.com/in/mikhail-trafimau-5621488b"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-footer-developer-link"
                        aria-label={t("footer.developedBy", { ns: namespaces.common })}
                    >
                        <img src={linkedinIcon} alt="LinkedIn" width="14" height="14" />
                    </a>
                </div>
                <ul className="app-footer-links">
                    {footerLinks.map(({ key, labelKey, href }) => (
                        <li key={key}>
                            <a href={href} className="app-footer-link">
                                {t(`footer.${labelKey}`, { ns: namespaces.common })}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </footer>
    );
};

export default Footer;
